export const INSTAGRAM_STORY_MEDIA = {
  height: 527,
  width: 270,
} as const;

/** Dark footer below media with send-message field. */
export const INSTAGRAM_STORY_CHIN_HEIGHT = 64;
